import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import SideBar from "./RetailBusinessSideBar";
import { API_URL } from "../../constant";

const BusinessLayout = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userData, setUserData] = useState(null);
  const [containerStyle, setContainerStyle] = useState({});

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    const token = localStorage.getItem("auth_token");
    if (!token) {
      navigate("/retail-agent-login");
      return;
    }

    setIsLoading(true);
    try {
      // Get user data only once
      const userResponse = await fetch(`${API_URL}/api/retail-business/me`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!userResponse.ok) {
        // If token is invalid, clear localStorage and redirect
        localStorage.removeItem("auth_token");
        localStorage.removeItem("user_type");
        throw new Error("Invalid or expired token");
      }
      
      const responseData = await userResponse.json();

      const transformedUser = {
        firstName: responseData.user.first_name,
        sureName: responseData.user.last_name,
        fullName: `${responseData.user.first_name} ${responseData.user.last_name}`,
        role:
          responseData.user.role === "SeniorBusinessAdsAgent"
            ? "Senior Business Ads Agent"
            : "Mini Business Ads Agent",
        avatar: responseData.user.photo_url || "",
        email: responseData.user.email,
        id: responseData.user.id,
        referralCode: responseData.user.referral_code,
      };

      setUserData(transformedUser);
      
      // Set background based on role (retail business gets #80302b to white)
      setContainerStyle(getContainerStyle());
      
    } catch (error) {
      console.error("Error fetching user data:", error);
      setError(error.message);
      // Redirect to login on error
      navigate("/retail-agent-login");
    } finally {
      setIsLoading(false);
    }
  };

  const getContainerStyle = () => {
    return {
      display: "flex",
      flexDirection: "column",
      marginTop: "0px",
      marginBottom: "0px",
      background: "linear-gradient(to bottom, #80302b, white)",
      width: "100%",
      minHeight: "100vh",
      fontFamily: "'Poppins', sans-serif"
    };
  };

  if (isLoading) {
    return (
      <div
        style={{
          ...containerStyle,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div style={{ marginTop: '20px' }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #3498db',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          ...containerStyle,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div style={{ color: "red" }}>Error: {error}</div>
      </div>
    );
  }

  return (
    <div style={containerStyle}>
      <SideBar user={userData} />
      <Outlet context={{ userData, fetchUserData }} />
    </div>
  );
};

export default BusinessLayout;